const ueccFleetBlocks = document.querySelectorAll('.uecc-block.uecc-fleet');

if (ueccFleetBlocks.length > 0) {
    
    ueccFleetBlocks.forEach((ueccFleetBlock) => {
        const fleetContainer = ueccFleetBlock.querySelector('.fleet');
        const fleetItems = ueccFleetBlock.querySelectorAll('.fleet-item');
        const vesselDetails = ueccFleetBlock.querySelectorAll('.vessel-details-container');


        // Functions
        function setResponsiveGrid() {
            const m = matchMedia('(max-width: 1280px)');
            const s = matchMedia('(max-width: 900px)');
            const xs = matchMedia('(max-width: 768px)');
            const xxs = matchMedia('(max-width: 600px)');

            let columns = 4;  
            fleetContainer.style.gridTemplateColumns = `repeat(${columns}, 214px)`;
  
            if (xxs.matches) {
                columns = 1;
                fleetContainer.style.gridTemplateColumns = `repeat(${columns}, 90%)`;

            } else if (s.matches) {
                columns = 2;
                fleetContainer.style.justifyContent = 'space-around';
                fleetContainer.style.gridTemplateColumns = `repeat(${columns}, 214px)`;


            } else if (m.matches) {
                columns = 3;
                fleetContainer.style.gridTemplateColumns = `repeat(${columns}, 214px)`;

            }


            // Set new grid rows
            fleetItems.forEach((fleetItem, index) => {
                const row = 1 + Math.floor(index / columns) * 2;
                const col = (index % columns) + 1;
                fleetItem.setAttribute('data-row', row);
                fleetItem.setAttribute('data-col', col);
            });
            vesselDetails.forEach((vesselDetail, index) => {
                const row = 2 + Math.floor(index / columns) * 2;
                vesselDetail.setAttribute('data-row', row);
            });
        }

        function clearActiveFleetItems() {
            fleetItems.forEach((item) => item.classList.remove('active'));
        }

        function closeAllVesselDetails() {
            const vesselDetailsElements = ueccFleetBlock.querySelectorAll('.vessel-details-container');
            vesselDetailsElements.forEach((vesselDetailsElement) => {
                vesselDetailsElement.style.height = '0';
                vesselDetailsElement.classList.remove('open');
            });
            clearActiveFleetItems();
        }
        function toggleVesselDetails(vesselDetailsElement) {
            vesselDetailsElement.classList.toggle('open');
            if (vesselDetailsElement.classList.contains('open')) {
                vesselDetailsElement.style.height = 'auto';
            } else {
                vesselDetailsElement.style.height = '0';
            }
        }

        function positionPointer(fleetItem, vesselDetailsElement) {
            const pointer = vesselDetailsElement.querySelector('.pointer');
            if (!pointer) return;

            const fleetItemRect = fleetItem.getBoundingClientRect();
            const containerRect = vesselDetailsElement.getBoundingClientRect();
            
            // Calculate the center of the fleet item relative to the container
            const fleetItemCenterX = fleetItemRect.left + (fleetItemRect.width / 2);
            const containerLeftX = containerRect.left;
            
            // Position pointer centered under the fleet item (pointer is 44px wide, rotated 45deg)
            const pointerWidth = 44;
            const pointerLeft = fleetItemCenterX - containerLeftX - (pointerWidth / 2);
            
            pointer.style.left = `${pointerLeft}px`;
        }

        function scrollToFleetItemRow(fleetItem, delayMs = 0) {
            if (!fleetItem) return;
            const doScroll = () => {
                fleetItem.scrollIntoView({ behavior: 'smooth', block: 'start' });
            };

            if (delayMs > 0) {
                setTimeout(doScroll, delayMs);
                return;
            }

            // Let layout settle before scrolling.
            requestAnimationFrame(() => requestAnimationFrame(doScroll));
        }

        function openVesselDetails(fleetItem, vesselDetailsElement) {
            closeAllVesselDetails();
            if (!vesselDetailsElement) return;
            toggleVesselDetails(vesselDetailsElement);
            positionPointer(fleetItem, vesselDetailsElement);
            fleetItem.classList.add('active');
            scrollToFleetItemRow(fleetItem);
        }

        function getHashSlug() {
            const rawHash = window.location.hash || '';
            const slug = rawHash.replace(/^#/, '').trim();
            return slug ? decodeURIComponent(slug).toLowerCase() : '';
        }

        function openVesselFromLocation() {
            const slug = getHashSlug();
            if (!slug) return;

            const fleetItem = ueccFleetBlock.querySelector(`.fleet-item[data-slug="${slug}"]`);
            if (!fleetItem) return;

            const vesselIndex = fleetItem.getAttribute('data-index');
            const vesselDetailsElement = ueccFleetBlock.querySelectorAll('.vessel-details-container')[vesselIndex];
            openVesselDetails(fleetItem, vesselDetailsElement);
            scrollToFleetItemRow(fleetItem, 650);
        }

        fleetItems.forEach((fleetItem) => {
            setResponsiveGrid();

            // Event listeners
            window.addEventListener('resize', setResponsiveGrid);

            fleetItem.addEventListener('click', () => {
                const vesselIndex = fleetItem.getAttribute('data-index');
                const vesselDetailsElement = ueccFleetBlock.querySelectorAll('.vessel-details-container')[vesselIndex];


                if (vesselDetailsElement.classList.contains('open')) {
                    closeAllVesselDetails();
                    return;
                }

                openVesselDetails(fleetItem, vesselDetailsElement);
            });
        });

        window.addEventListener('hashchange', openVesselFromLocation);
        openVesselFromLocation();
    });
}